import axios from 'axios';
import requestInterceptor from './requestInterceptor';

const defaultMimeType = 'application/json';

const channelApiInstance = axios.create({
  baseURL: process.env.API_URL,
  timeout: 30000,
  headers: { 'Content-Type': defaultMimeType, Accept: defaultMimeType }
});

// Add a request interceptor
channelApiInstance.interceptors.request.use(requestInterceptor);

export default channelApiInstance;



// WEBPACK FOOTER //
// ./src/common/api/channelApi.js